export const downloadFileLocally = (file: File) => {
    const url = URL.createObjectURL(new Blob([file], { type: file.type }));
    const a = document.createElement('a');
    a.href = url;
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export const formatFileSize = (size: number) => {
    if (size < 1024) {
        return `${size} B`;
    }

    if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)} KB`;
    }

    if (size < 1024 * 1024 * 1024) {
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    }

    return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const generateDefaultDisplayText = (
    maxNumberOfFiles: number,
    acceptedFileTypes: string | string[] | undefined,
    required = false
) => {
    const fileText = maxNumberOfFiles < 2 ? 'file' : 'file(s)';
    const requiredMark = required ? ' *' : '';

    if (acceptedFileTypes === undefined) {
        return `Drag and drop ${fileText} here${requiredMark}`;
    }

    const fileTypeString = Array.isArray(acceptedFileTypes) && acceptedFileTypes.length > 1 ? 'types' : 'type';
    const acceptedFileTypesString = Array.isArray(acceptedFileTypes) ? acceptedFileTypes.join(', ') : acceptedFileTypes;

    return `Drag and drop ${fileText} here${requiredMark} \n Supported ${fileTypeString} - ${acceptedFileTypesString}`;
};
